import { ButtonType } from '../../types/enums';
import Button from '../Button/Button';

import plusIcon from './plus-solid.svg';

import styles from './AddNew.module.scss';

const AddNew = ({ action, title }: { title: string; action: () => void }) => {
  return (
    <Button action={action} type={ButtonType.PRIMARY} spaceSaving>
      <div className={styles.button}>
        <img src={plusIcon} alt="plus" />
        {title}
      </div>
    </Button>
  );
};

export default AddNew;
